// removed by extract-text-webpack-plugin
module.exports = {"content-header-wrapper":"content-header-wrapper","contentHeaderWrapper":"content-header-wrapper","content-teams-header":"content-teams-header","contentTeamsHeader":"content-teams-header","edit-teams-wrapper":"edit-teams-wrapper","editTeamsWrapper":"edit-teams-wrapper","teams-menu-button-wrapper":"teams-menu-button-wrapper","teamsMenuButtonWrapper":"teams-menu-button-wrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/teams/teamsMainContainer/style.scss
// module id = 1393
// module chunks = 0